import apiRequest from 'root/src/client/logic/api/thunks/apiRequest'
import currentRouteParamsRecordId from 'root/src/client/logic/route/selectors/currentRouteParamsRecordId'
import { REJECT_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import onSuccessRedirectSelectorSelector from 'root/src/client/logic/route/selectors/onSuccessRedirectSelectorSelector'
import setShareUrl from 'root/src/client/logic/static/actions/setShareUrl'
import path from 'ramda/src/path'

export default ({ message }, { moduleId }) => async (dispatch, getState) => {
	const state = getState()
	const projectUrl = currentRouteParamsRecordId(state)

	const apiPayload = {
		projectUrl,
		message: message || 'Creator didn\'t accept',
	}

	const successPage = onSuccessRedirectSelectorSelector(state, { moduleId, submitIndex: 0 })
	const response = await dispatch(apiRequest(REJECT_PROJECT, apiPayload))
	dispatch(setShareUrl(path(['body', 'shareUrl'], response)))
	return { ...response, ...successPage }
}
